export default "__VITE_ASSET__0f0fff84__"